import Vue from "vue";
import BN from "bignumber.js";

export const findNatural = value => {
  return new BN(
    new BN(String(value || 0).replace(/\,/g, "")).toFixed(18).split(".")[0]
  ).toFormat(0);
};

export const findFractional = (value, maxLength = 8, minLength = 2) => {
  const str = new BN(String(value || 0).replace(/\,/g, ""))
    .toFixed(18)
    .split(".")[1]
    .padEnd(minLength, "0")
    .slice(0, maxLength);
  if (!Number(str)) return "".padEnd(minLength, "0");
  return str;
};

export const abs = value => Math.abs(value);

Vue.filter("natural", findNatural);
Vue.filter("fractional", findFractional);
Vue.filter("abs", abs);
